/**
Copyright (c) 2022–2026 Podstack.ai
All rights reserved.
Proprietary and Confidential.
Unauthorized copying of this file, via any medium, is strictly prohibited.
This file is part of the Podstack Platform.
*/

import React from 'react';
import ApiKeysSection from '../../components/settings/ApiKeysSection';
import SSHKeysSection from '../../components/settings/SSHKeysSection';

// Settings → Access keys: API keys + SSH keys on one screen (artboard 12).
const AccessKeysSettings: React.FC = () => (
  <>
    <ApiKeysSection />
    <SSHKeysSection />
  </>
);

export default AccessKeysSettings;
